/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useEffect, useState } from "react";
import EmptyList from "../../common/form/EmptyList";
import { useSelector } from "react-redux";
import PaginationComponent from "../../common/form/PaginationComponent";

const AppliedJobs = () => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const { t } = useTranslation('common');
  const [select, setSelect] = useState<any>("")
  const [categoryList, setCategoryList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [data, setData] = useState<any[]>([])
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
  const loaderData: any[] = [1, 2, 3, 4, 5]
  let totalPages: number = Math.ceil(total / +size?.value);

  const getCategory = async () => {
    try {
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.applyStatus}`);

      if (res && res.status === 200) {
        setCategoryList(res?.data?.results)
        if (res?.data?.results?.length > 0) {
          let arr: any[] = []
          for (let i = 0; i < res?.data?.results.length; i++) {
            const el = res?.data?.results[i];
            el.status_name = el?.status?.replace("_", " ")
            arr.push(el)
          }
        } else {
          setCategoryList([])
        }
        !!select ? setSelect(select) : ((res?.data?.results?.length > 0) ? !!!select ? setSelect(res?.data?.results?.[0]?.status) : setSelect(select) : setSelect(""))
      }
    } catch (error) {
      console.error("error while fetching status", error);
    }
  }

  const getJob = async () => {
    try {
      setLoading(true)
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.my_applied_jobs}?status=${select}&page=${page}&size=${+size?.value}`);

      if (res && res.status === 200) {
        setData(res?.data?.results)
        setTotal(res?.data?.count)
        setLoading(false)
      }
    } catch (error) {
      console.error("error while fetching job", error);
    }
  }

  useEffect(() => {
    !!lang && getCategory();
  }, [lang])

  useEffect(() => {
    window.scrollTo(0, 0);
    (!!select && !!lang) && getJob();
  }, [select, page, size, lang])

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col gap-[5px] w-full pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2]">
        <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.tabs.applied_jobs")}</h3>
        <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{t("profile.applied_jobs_desc")}</h6>
      </div>

      <div className="flex items-center gap-[8px] w-full border-b border-primary border-opacity-[0.2] px-[15px] md:px-[30px] xlx:px-[35px]">
        {Array.isArray(categoryList) && categoryList?.map((item: any, index: number) => (
          <button key={index} className={`${select === item?.status ? "text-primaryText dark:text-white border-b-[2px] border-primary" : "text-blackDull dark:text-textBlackDull focus:text-primaryText hover:text-primaryText dark:focus:text-white dark:hover:text-white focus:underline hover:underline border-b-[2px] border-transparent"} capitalize text-sm font-medium py-[6px] px-[16px]`} onClick={() => setSelect(item?.status)}>{item?.status_name}</button>
        ))}
      </div>

      <div className="w-full h-full flex flex-col gap-[20px] items-center justify-center py-[20px] px-[15px] md:p-[30px] xlx:px-[35px]">
        {loading ?
          <div className="overflow-x-auto h-full w-full">
            <div className="inline-block min-w-full">
              <div className="overflow-hidden">
                <table className="table-auto w-full">
                  <thead className="w-full">
                    <tr className="w-full bg-[#D9D9D9] dark:border-[#454545]  bg-opacity-[0.3] border border-[#D9D9D9] dark:bg-[#3f4143] border-opacity-[0.3]">
                      <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                        {t("recruitment.home.job_list.dept")}
                      </th>
                      <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                        {t("recruitment.home.job_list.category")}
                      </th>
                      <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-center">
                        {t("recruitment.home.job_list.grade")}
                      </th>
                      <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                        {t("recruitment.home.job_list.emp")}
                      </th>
                      <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                        {t("recruitment.home.job_list.pay_scale")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                      <tr className="w-full animate-pulse border border-gray-200 dark:border-gray-700" key={index}>
                        <td className="px-[16px] py-[15px] xlx:py-[16px]">
                          <div className="flex flex-col gap-[4px]">
                            <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                            <div className="w-[120px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                          </div>
                        </td>

                        <td className="px-[16px] py-[15px] xlx:py-[16px]">
                          <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        </td>

                        <td className="px-[16px] py-[15px] xlx:py-[16px]">
                          <div className="flex items-center justify-center">
                            <div className="w-[20px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                          </div>
                        </td>

                        <td className="px-[16px] py-[15px] xlx:py-[16px]">
                          <div className="flex items-center gap-[8px]">
                            <div className="h-[22px] xlx:h-[25px] rounded-full w-[80px] bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-[22px] xlx:h-[25px] rounded-full w-[80px] bg-gray-200 dark:bg-gray-700"></div>
                          </div>
                        </td>

                        <td className="px-[16px] py-[15px] xlx:py-[16px]">
                          <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          :
          <>
            {(data?.length > 0) ? <>
              <div className="overflow-x-auto h-full w-full">
                <div className="inline-block min-w-full">
                  <div className="overflow-hidden">
                    <table className="table-auto w-full">
                      <thead className="w-full">
                        <tr className="w-full bg-[#D9D9D9] dark:border-[#454545]  bg-opacity-[0.3] border border-[#D9D9D9] dark:bg-[#3f4143] border-opacity-[0.3]">
                          <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                            {t("recruitment.home.job_list.dept")}
                          </th>
                          <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                            {t("recruitment.home.job_list.category")}
                          </th>
                          <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-center">
                            {t("recruitment.home.job_list.grade")}
                          </th>
                          <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                            {t("recruitment.home.job_list.emp")}
                          </th>
                          <th className="px-[16px] py-[3px] xlx:py-[6px] h-full text-blackDark dark:text-textBlackDark font-bold text-sm leading-snug !text-left">
                            {t("recruitment.home.job_list.pay_scale")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) && data.map((item: any, index: number) => (
                          <tr className={`${((index % 2) === 0) ? "bg-[#FCFCFC] dark:bg-[#343539]" : "bg-[#F6F9FC] dark:bg-[#3f4143]"} border border-[#E5E5E5] dark:border-[#454545]`} key={index}>
                            <td className="px-[16px] py-[15px] xlx:py-[16px]">
                              <div className="flex flex-col gap-[4px] w-[160px] xlx:w-[180px]">
                                <p className="text-blackDull dark:text-textBlackDull font-medium">{item?.job_details?.department_name}</p>
                                <h6 className="font-semibold text-primaryText dark:text-white">{item?.job_details?.job_role}</h6>
                              </div>
                            </td>
                            <td className="px-[16px] py-[15px] xlx:py-[16px] text-sm leading-snug font-semibold text-blackDark dark:text-textBlackDark">
                              <div className="flex items-start gap-[3px] whitespace-nowrap">
                                {(Array.isArray(item?.job_details?.post_category_detail) && item?.job_details?.post_category_detail?.map((i: any, idx: number) =>
                                  <h6 className="text-blackDark dark:text-textBlackDark font-semibold" key={idx}>
                                    {(i?.category) + " - " + (i?.post_available) + `${item?.job_details?.post_category_detail?.length !== idx + 1 ? ' | ' : ' '}`}
                                  </h6>
                                ))}
                              </div>
                            </td>
                            <td className="px-[16px] py-[15px] xlx:py-[16px] text-sm leading-snug font-semibold text-blackDark dark:text-textBlackDark text-center">
                              {!!item?.job_details?.grade_pay_details?.grade_code ? item?.job_details?.grade_pay_details?.grade_code : "-"}
                            </td>
                            <td className="px-[16px] py-[15px] xlx:py-[16px]">
                              <div className="flex items-center gap-[8px]">
                                {Array?.isArray(item?.job_details?.employment_nature_details) && item?.job_details?.employment_nature_details?.map((i: any, index: number) => (
                                  <div key={index} className="bg-[#F1F1F1] dark:bg-[#d4d5d838] rounded-[30px] px-[15px] py-[3px] flex items-center justify-center w-fit text-blackDull dark:text-textBlackDull font-semibold text-sm leading-snug">
                                    {i?.name}
                                  </div>
                                ))}
                              </div>
                            </td>

                            <td className="px-[16px] py-[15px] xlx:py-[16px] text-sm leading-snug font-semibold text-blackDark dark:text-textBlackDark whitespace-nowrap">
                              {!!item?.job_details?.grade_pay_details?.pay_scale ? item?.job_details?.grade_pay_details?.pay_scale : `₹ ${item?.job_details?.annual_ctc}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center w-full mt-[10px]">
                <PaginationComponent
                  page={page}
                  total={totalPages}
                  setPage={setPage}
                />
              </div>
            </> :
              <EmptyList />
            }
          </>
        }
      </div>
    </div>
  );
};

export default AppliedJobs;